import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON,
  SystemCodeToJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface DueDate {
  classification: SystemCode
  dueDate: string
}

export function DueDateFromJSON(json: any): DueDate {
  return DueDateFromJSONTyped(json)
}

export function DueDateFromJSONTyped(json: any): DueDate {
  if (json === undefined || json === null) {
    return json
  }
  return {
    classification: exists(json, 'classification')
      ? SystemCodeFromJSON(json.classification)
      : defaultSystemCode(),
    dueDate: exists(json, 'due_date') ? dateToPlainFormat(json.due_date) : ''
  }
}

export function DueDateToJSON(value: DueDate): any {
  return {
    classification: SystemCodeToJSON(value.classification),
    due_date: value.dueDate
  }
}
